import { render } from "./ProductModalLists.vue?vue&type=template&id=1eb9af13"
import script from "./ProductModalLists.vue?vue&type=script&lang=js"
export * from "./ProductModalLists.vue?vue&type=script&lang=js"

import "./ProductModalLists.vue?vue&type=style&index=0&id=1eb9af13&lang=scss"

import exportComponent from "/var/www/hi5admin_demo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__